import { z } from 'zod'

import { EnumBuilder } from '@mntn-dev/utility-types'
import { ModelFilterSchema } from '../model-filter-schema.ts'
import {
  ActivityIdSchema,
  NotificationIdSchema,
  UserIdSchema,
} from './unique-id.models.ts'

export const [
  NotificationStatuses,
  NotificationStatusSchema,
  NotificationStatusEnum,
] = EnumBuilder('unread', 'read')
export type NotificationStatus = z.infer<typeof NotificationStatusSchema>

/**
 * NotificationDomainSelectModel
 */
export const NotificationDomainSelectModelSchema = z.object({
  notificationId: NotificationIdSchema,
  recipientId: UserIdSchema,
  activityId: ActivityIdSchema,
  status: NotificationStatusSchema,
})

export type NotificationDomainSelectModel = z.infer<
  typeof NotificationDomainSelectModelSchema
>

/**
 * NotificationDomainInsertModel
 */
export const NotificationDomainInsertModelSchema =
  NotificationDomainSelectModelSchema.omit({ status: true }).partial({
    notificationId: true,
  })

export type NotificationDomainInsertModel = z.infer<
  typeof NotificationDomainInsertModelSchema
>

/**
 * NotificationDomainUpdateModel
 */
export const NotificationDomainUpdateModelSchema =
  NotificationDomainSelectModelSchema.pick({
    status: true,
  }).partial()

export type NotificationDomainUpdateModel = z.infer<
  typeof NotificationDomainUpdateModelSchema
>

/**
 * NotificationDomainSelectModelFilters
 */
export const NotificationDomainSelectModelFiltersSchema = z
  .object({
    notificationId: ModelFilterSchema(NotificationIdSchema),
    recipientId: ModelFilterSchema(UserIdSchema),
    status: ModelFilterSchema(NotificationStatusSchema),
  })
  .partial()

export type NotificationDomainSelectModelFilters = z.infer<
  typeof NotificationDomainSelectModelFiltersSchema
>
